/**
 * FusionAuditPanel.jsx — iter846 (Feb 2026)
 *
 * Extracted from BreastHealthIntelligencePage.jsx. Shows transparent audit
 * of which DUTCH/DNA modifiers adjusted the metabolic sub-environment
 * scores. Rendered inside the metabolic section header.
 */
import React from "react";

export default function FusionAuditPanel({ fusion, lang, isDark }) {
  const tx = {
    bg: { title: "🧬 Защо тези скорове са корегирани",
          sub:  "Корекциите идват от качените Ви DUTCH/ДНК данни. Всеки фактор е прозрачен — задръжте курсора върху pill-ите по-горе да видите базовия скор.",
          per:  "Общ ефект по измерение:",
          src:  "Източник", reason: "Причина" },
    en: { title: "🧬 Why these scores were adjusted",
          sub:  "Adjustments come from your DUTCH/DNA uploads. Every modifier is transparent — hover the pills above to see the base score.",
          per:  "Net effect per dimension:",
          src:  "Source", reason: "Reason" },
    es: { title: "🧬 Por qué se ajustaron estas puntuaciones",
          sub:  "Los ajustes provienen de sus datos DUTCH/ADN cargados. Cada modificador es transparente.",
          per:  "Efecto neto por dimensión:",
          src:  "Fuente", reason: "Razón" },
  };
  const t = tx[lang] || tx.bg;
  // iter847 — Defensive null guard: parent may render this component
  // before fusion data is loaded (e.g. during snapshot refresh).
  if (!fusion || !Array.isArray(fusion.modifiers) || fusion.modifiers.length === 0) return null;
  return (
    <div
      className={`mt-3 p-4 rounded-xl border ${isDark ? "border-purple-500/30 bg-purple-500/5" : "border-purple-200 bg-purple-50/50"}`}
      data-testid="fusion-audit-panel"
    >
      <div className={`text-xs font-bold mb-1 ${isDark ? "text-purple-300" : "text-purple-700"}`}>{t.title}</div>
      <p className="text-[11px] opacity-70 mb-2">{t.sub}</p>
      {Object.keys(fusion.per_dimension_delta || {}).length > 0 && (
        <div className="flex flex-wrap gap-1 mb-2">
          {Object.entries(fusion.per_dimension_delta).map(([dim, delta]) => (
            <span
              key={dim}
              className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${
                delta < 0
                  ? "bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300"
                  : "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300"
              }`}
              data-testid={`fusion-per-dim-${dim}`}
            >
              {dim}: {delta > 0 ? "+" : ""}{delta}
            </span>
          ))}
        </div>
      )}
      <ul className="space-y-1.5 text-xs">
        {fusion.modifiers.map((m, i) => (
          <li key={i} className="flex items-start gap-2" data-testid={`fusion-mod-${i}`}>
            <span className={`shrink-0 font-bold ${m.delta < 0 ? "text-orange-500" : "text-emerald-500"}`}>
              {m.delta > 0 ? "+" : ""}{m.delta}
            </span>
            <div className="flex-1">
              <div className={isDark ? "text-gray-200" : "text-gray-800"}>{m.reason}</div>
              <div className="text-[10px] opacity-50 italic mt-0.5">{t.src}: {m.source}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
